// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BookOutlinedSvg from "@ant-design/icons-svg/es/asn/BookOutlined";
import AntdIcon from '../components/AntdIcon';

var BookOutlined = function BookOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BookOutlinedSvg
  }));
};

BookOutlined.displayName = 'BookOutlined';
export default React.forwardRef(BookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BookOutlined.js
// module id = 651
// module chunks = 0